import React, { Component } from 'react';
import Item1 from '../Static/accessories/adjusted-max-w-flat.jpg';
import Item2 from '../Static/accessories/DSC_0087.jpg';
import Item3 from '../Static/accessories/DSC01952.jpg';
import Item4 from '../Static/accessories/DSC01945.jpg';
import Item5 from '../Static/accessories/NwVac3.jpg';
import Item6 from '../Static/accessories/DSC_0010.jpg';
import ChangeLocale from "../Components/changeLocale";
import GoBack from "../Components/goBack";
import {FormattedMessage, FormattedHTMLMessage} from "react-intl";

class Accessories extends Component {
	render() {
		const { locale, changeLocale } = this.props;

		return (
			<>
				<GoBack />
				<ChangeLocale locale={locale} changeLocale={changeLocale} />
				<h2>PRÍSLUŠENSTVO</h2>
				<h3>MUCK TRUCK PRÍSLUŠENSTVO VÁM POMÔŽE ZÍSKAŤ MAXIMÁLNE VYUŽITIE VŠETKÝCH SHOPNOSTÍ VÁŠHO MUCK TRUCK!</h3>
				<h4>Pozrite si kompletný sortiment príslušenstva  pre váš Muck-Truck® - na montáž nebudete potrebovať žiadne špeciálne náradie. Všetky prídavné zariadenia  sú zameniteľné a dajú sa použiť s akoukoľvek konfiguráciou mini prepravníka  Muck-Truck®.</h4>

				<div className='row no-wrap with-margin-top'>
					<div className='text-align--left'>
						<b><FormattedMessage id='flatbedTitle' /></b>
						<p><FormattedMessage id='flatbedContent' /></p>
						{/*<p>Najobľúbenejší doplnok Muck Truck  Plošina je ideálna pre všetky tie nepríjemné bremená, ktoré sa nedajú ľahko prepraviť alebo premiestniť. Plošina sedí nad kolesami, preto aj nadrozmerné náklady môžu byť prepravované s ľahkosťou.</p>*/}
						Rozmery:  600 mm x  600 mm x  600 mm <br/>
						Hmotnosť: 25 kg <br/>
						Nosnosť : 250 kg <br/>
						Poskladaní v priebehu niekoľkých sekúnd
					</div>
					<img className='margin-left-20' decoding="async" src={Item1} alt='nakladna plosina' />
				</div>

				<div className='row no-wrap with-margin-top'>
					<div className='text-align--left'>
						<b><FormattedMessage id='loadingRampTitle' /></b>
						<p><FormattedMessage id='loadingRampContent' /></p>
						{/*<b>Muck-Truck® - nakladacia – nájazdová rampa</b>*/}
						{/*<p>Nakladacia rampa, robustne konštruovaná, umožňuje bezpečný nájazd a vyklápanie do vozíka, kontajnera alebo kamiónu. Jednoduchá montáž na mieste jednou osobou. Ako sa rýchlo rozloží, tak sa aj rýchlo zloží, pre ľahkú prepravu.</p>*/}
						Rozmery: šírka 778 mm, dĺžka 2 x  1520 mm<br/>
						Hmotnosť: 95 kg
					</div>
					<img className='margin-left-20' decoding="async" src={Item2} alt='najazdova rampa' />
				</div>

				<div className='row no-wrap with-margin-top'>
					<div className='text-align--left'>
						<b><FormattedMessage id='bucketExtensionTitle' /></b>
						<p><FormattedMessage id='bucketExtensionContent' /></p>
						{/*<b>Muck-Truck®- rozširovacie bočnice</b>*/}
						{/*<p>Tieto sú obľúbené u záhradníkov, krajinárov, v  jazdeckých centrách, na farmách a pod. Poskytujú 30% väčšiu kapacitu pre náklady ako je kompost, hnoj, mulčovacej kôry, seno, slama atď</p>*/}
						rozmery: výška 300 mm
					</div>
					<img className='margin-left-20' decoding="async" src={Item3} alt='rosirovacie bocnice' />
				</div>

				<div className='row no-wrap with-margin-top'>
					<div className='text-align--left'>
						<b><FormattedMessage id='ballHitchTitle' /></b>
						<p><FormattedMessage id='ballHitchContent' /></p>
						{/*<p>Môže byť použitý pre prívesy, karavany, lode alebo iné stroje. Muck Truck  môže ťahať alebo  tlačiť až do ich celkovej hmotnosti  2,5 tony, nakoľko je veľmi obratný a veľmi silný.</p>*/}
						{/* // TODO chyba velkost gule */}
						Hmotnosť: 5 kg
					</div>
					<img className='margin-left-20' decoding="async" src={Item4} alt='gulovy zaves' />
				</div>

				<div className='row no-wrap with-margin-top'>
					<div className='text-align--left'>
						<b>Muck-truck® Paddock Vacuum</b>
						<p><FormattedHTMLMessage id='vacuumContent' /></p>
						{/*<p>Systém Vákuum muck-truck ™ sa jednoducho ovláda.Benzínový motor Kawasaki vytvára v zbernej nádobe vákuum, ktoré ponúka silné nasávanie cez zbernú hadicu  s priemerom 12,5cm. Zberná nádoba je vyrobená z odolného plastu s vysokou hustotou a ľahko sa vyprázdňuje zdvihnutím prednej časti smerom nahor a zaistením v otvorenej polohe.  Vákuum možno použiť na zber konského hnoja, listov, úlomkov, vody alebo iných odpadových materiálov</p>*/}
						Kapacita: nádoba na 350 litrov<br/>
						 Dĺžka hadice: 3m<br/>
						 Nosnosť:  250 kg
					</div>
					<img className='margin-left-20' decoding="async" src={Item5} alt='vysavac' />
				</div>

				<div className='row no-wrap with-margin-top'>
					<div className='text-align--left'>
						<b><FormattedMessage id='snowPloughTitle' /></b>
						<p>Snežný pluh je ľahko pripevniteľný k prednej časti stroja. Ideálne na odstraňovanie snehu. Použitie je možné tiež na farmách na odstraňovanie kalov a pod. Radlica sa  môže pri otáčaní zdvihnúť a pre lepší výkon  môže byť pri práci menený uhol, aby sa sneh posunul v požadovanom smere.</p>
						Šírka radlice:  1220 mm<br/>
						 Hmotnosť: 35 kg
					</div>
					<img className='margin-left-20' decoding="async" src={Item6} alt='snezny pluh' />
				</div>
			</>
		);
	}
}

export default Accessories;
